<div class="input-group input-group-sm">
    <spv2-return-type-dropdown [searchString]="searchString" [(value)]="value" (valueChange)="valueChange.emit($event)" (userChangedValue)="startDebounce();" [smallView]="smallView" ></spv2-return-type-dropdown>
</div>  